import React, {useEffect, useState} from "react";
import { useNavigate } from 'react-router-dom';
import SEO from "../components/SEO";

import * as queryService from "../_services/query.service.js";

import {toast} from "react-hot-toast";
import { useUser } from "../context/UserContext";

import "../styles/ContactUsPage.css";

export default function ContactUsPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const { user } = useUser();
  const [errors, setErrors] = useState({});
  
  const initialFormData = {
    fullName: user?.fullName || "",
    emailAddress: user?.emailAddress || "",
    mobileNumber: "",
    subject:"",
    message:"",
  }
  
  const [formData, setFormData] = useState(initialFormData);
  
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
  
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
  
    setLoading(true);
    setValidated(true);
  
    try {
      const result = await queryService.submitQuery(formData);
      
      toast.success(result.message);
       
      setFormData(initialFormData);
      
    } catch (error) {
      toast.error(error.message || `Something went wrong. Please try again.`);
    } finally {
      setLoading(false)
    }
  };
    
  return (
    <>
      <SEO
        title="Contact Magyne | Business Management Software"
        description="Contact Magyne to learn more about our SaaS and ERP solutions for schools, healthcare organizations, businesses and other organizations."
        path="/contact"
      />

      <main>
        <div className="contact-page">
          {/* Animated Background Blobs */}
          <div className="bg-blobs">
            <div className="blob blob1"></div>
            <div className="blob blob2"></div>
            <div className="blob blob3"></div>
          </div>

          {/* Hero / Intro */}
          <section className="contact-hero">
            <h1>Get in Touch</h1>
            <p>
              Interested in Magyne? Contact our team to learn how our
              business management solutions can support your organization.
            </p>
          </section>

          {/* Contact Form */}
          <section className="contact-section">
            <div className="contact-container">
              <div className="contact-info h-md-100">
                <h2>Contact Info</h2>
                <p><strong>Email:</strong> <a href="mailto:services@magyne.com">services@magyne.com</a></p>
                <p><strong>Phone:</strong> <a href="tel:+260979790441">+260 979 790 441</a></p>
                <p><strong>Address:</strong> Lusaka, Zambia</p>
              </div>
              <form className="contact-form" onSubmit={handleSubmit}>
                <h2>Send Us a Message</h2>
                <input 
                  type="text" 
                  placeholder="Your Name" 
                  required 
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                />
                <input 
                  type="email" 
                  placeholder="Email Address" 
                  required 
                  name="emailAddress"
                  value={formData.emailAddress}
                  onChange={handleChange}
                />
                <input 
                  type="text" 
                  placeholder="Mobile number" 
                  required 
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                />
                <input 
                  type="text" 
                  placeholder="Subject" 
                  required
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                />
                <textarea 
                  placeholder="Your Message" 
                  rows="3" 
                  required
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>

                <button type="submit">
                  {
                    loading 
                    ? <div className="spinner"></div>
                    : <div>
                        <i className="bi bi-envelope m-2"></i>  
                        Submit Query
                      </div>
                  }
                </button>
              </form>

            </div>
          </section>

          {/* Floating Shapes */}
          <div className="floating-shape shape1"></div>
          <div className="floating-shape shape2"></div>
          <div className="floating-shape shape3"></div>
        </div>
      </main>
    </>
  );
}
